import React, { useState } from 'react';
import IconUpload from './assets/icon-upload.svg';
import Dropzone from 'react-dropzone';
import UploadItem from './upload-item';
import './upload.scss';
import { DocumentUploadS3 } from 'generated/credit-analysis-graphql';

type DocumentUploaderProps = {
    title?: string;
    className?: string;
    filesLimit?: number;
    id?: string;
    getSignedUrl:(filename: string, contentType: string) => Promise<DocumentUploadS3>;
    onUploadComplete:() => void;
    documentDescription?:() => JSX.Element;
};

const acceptedContentTypes = [
    'application/pdf',
];

const DocumentUploader: React.FC<DocumentUploaderProps> = ({
    title = 'enviar arquivo',
    className,
    filesLimit,
    id,
    getSignedUrl,
    onUploadComplete,
    documentDescription,
}) => {

    const [documents, setDocuments] = useState<File[]>([]);

    const isValidFileSize = (file: File) => {
        const limitInMB = 20;
        const size = Math.round(file.size / 1024 / 1024);
        const isValid = size <= limitInMB;

        if (!isValid) {
            alert(`Limite para tamanho de arquivo excedido: ${limitInMB}MB`);
        }

        return isValid;
    }

    const handleUpload = (files: File[]) => {
        if (filesLimit) {
            const isTooManyDraggedFiles = files.length > filesLimit;
            const isOverflow = (documents.length + files.length) > filesLimit;

            if (isTooManyDraggedFiles || isLimitReached() || isOverflow) {
                alert(`Limite de ${filesLimit} arquivo(s) excedido`);
                return;
            }
        }
        setDocuments([...documents, ...files.filter(isValidFileSize)])
    }

    const handleUploadError = (indexToRemove: number) =>
        setDocuments([...documents.filter((f, index) => indexToRemove !== index)]);

    const isLimitReached = () => filesLimit && documents.length === filesLimit;

    const limitLabel = () => {
        const fileLabel = filesLimit === 1 ? 'limite de 1 arquivo' : `limite de ${filesLimit} arquivos`;
        const addedLabel = documents.length === 1 ? '1 adicionado' : `${documents.length} adicionados`;

        return `${fileLabel} - ${addedLabel}`;
    };

    return (
        <div className={className}>
            <Dropzone
                accept={acceptedContentTypes}
                onDropAccepted={handleUpload}
                disabled={documents.length === filesLimit} >
                {({ getRootProps, getInputProps }) => (
                    <div
                        {...getRootProps()}
                        className={`area__upload ${isLimitReached() ? 'disabled' : ''} container__upload`}
                        title={isLimitReached() ? `Limite de ${filesLimit} arquivo(s) atingido` : ''}
                    >
                        <div>
                            <img src={IconUpload} alt="icon__upload" className="icon__upload" />
                            <div className="subtitle">{title}</div>
                            <label className="overline">apenas PDF</label>
                            {filesLimit && (
                                <div className="overline mt-2">{limitLabel()}</div>
                            )}
                        </div>
                        <input id={id || ''} {...getInputProps()} />
                    </div>
                )}
            </Dropzone>

            {documentDescription && (
                <div className="mt-4 mb-4">
                    {documentDescription()}
                </div>
            )}

            {documents.length > 0 && (
                <div className="mb-4">
                    {documents.map((file, index) => (
                        <UploadItem
                            key={index}
                            getSignedUrl={getSignedUrl}
                            onComplete={onUploadComplete}
                            onError={() => handleUploadError(index)}
                            documentFile={file}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default DocumentUploader;
